import { FetchIdeasApiResponse } from '../api/IdeasMethodExecutor/IdeasMethodExecutor';

import { CanvasIdea } from './typings';

export const mapResponseToIdeas = (fetchResult: FetchIdeasApiResponse): CanvasIdea[] => {
    return fetchResult.items.reduce((acc: CanvasIdea[], idea: CanvasIdea) => {
        const isAdaptive = idea.data.options.isAdaptive ? true : false;

        if (isAdaptive) {
            // адаптивный шаблон только один, поэтому можно
            // игнорировать тот факт, что в такой логике адаптивные
            // шаблоны лягут в массив в обратном порядке
            return [idea, ...acc];
        }

        return [...acc, idea];
    }, []);
};
